import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'

import { Kirjanpitotili, KirjauksenTositteenTyyppi } from '../../_jaettu-lemonator/model/kirjanpito'
import { Reskontravienti } from '../../_jaettu-lemonator/model/reskontra'

import { animate, state, style, transition, trigger } from '@angular/animations'
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { TypeaheadToimittajaIlmanAvainta } from '@lemon/core-firebase/model/lasku'
import { SAHKOISET_LASKUT_MAKSUTAPA_ID } from '@lemon/core-firebase/model/tosite'
import { NumberDate } from '@lemon/core/model/common'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { AsiakkaanMaksutapa } from 'app/_jaettu-lemonator/model/asiakas'
import { KirjanpitoReskontraUriService } from 'app/_jaettu-lemonator/service/kirjanpito-reskontra-uri.service'
import { Observable, Subject, map } from 'rxjs'

enum ViewType {
  NORMAALI = 'normaali',
  SAHKOINEN_OSTOLASKU = 'sahkoinen_ostolasku',
  SAHKOINEN_OSTOLASKU_ITSE_LISATTY = 'sahkoinen_ostolasku_itse_lisatty',
}

interface RenderableReskontraRow {
  leftColumnVienti: Reskontravienti
  rightColumnConnectedViennit: Reskontravienti[]
  unconnectedRight: Reskontravienti
}

@Component({
  selector: '[app-kirjanpito-reskontra-single-box]',
  templateUrl: './reskontra-single-box.component.html',
  styleUrls: ['./reskontra-single-box.component.css'],
  animations: [
    trigger('blueBorderFade', [
      state(
        'true',
        style({
          borderColor: '#346fdc',
        }),
      ),
      state(
        'false',
        style({
          borderColor: 'rgb(124, 124, 124)',
        }),
      ),
      transition('true => false', [animate('0.6s')]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjanpitoReskontraSingleBoxComponent implements OnInit, OnDestroy {
  @Output() openKirjaus: EventEmitter<{ kirjausAvain: string; pvm: NumberDate; maksutapa: number }> = new EventEmitter()
  @Input() isSelected: boolean = false
  @Input() vienti: Reskontravienti
  @Input() maksutapa: AsiakkaanMaksutapa
  @Input() toimittaja: TypeaheadToimittajaIlmanAvainta
  /**
   * Only feed this to the component for admin users!
   */
  @Input() debugUrlStart: string = null

  private _ngUnsubscribe = new Subject<void>()

  namename: string = 'afasdfasdfayuiopålkjhgf' + new Date().getTime()
  showCommonError: boolean = false

  reskontraTilitObservable: Observable<Kirjanpitotili[]>
  renderableReskontraRowsObservable: Observable<RenderableReskontraRow[]>
  dynamicBoxHeight: string
  screenSizeObservable: Observable<{ small: boolean }>

  readonly ViewType = ViewType

  public set setBoxHeight(connections: number) {
    const height = connections * 77.5 + 'px;'
    this.dynamicBoxHeight = height
  }

  constructor(
    private _kayttajaService: KirjautunutKayttajaService,
    private _breakpointObserver: BreakpointObserver,
    private _reskontraUriService: KirjanpitoReskontraUriService,
  ) {}

  ngOnInit() {
    this.screenSizeObservable = this._breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, '(min-width: 1280px) and (max-width: 1599.99px)']).pipe(
      map(br => {
        return { small: br.matches }
      }),
    )
  }

  emitKirjausOpen(e: Event) {
    e.preventDefault()
    e.stopPropagation()

    const kirjausAvain = this.vienti.av.split(this._reskontraUriService.getVientiAvainSeparator())[0]
    this.openKirjaus.emit({ kirjausAvain: kirjausAvain, pvm: this.vienti.p, maksutapa: this.vienti.mt })
  }

  debugRedirectIfAdmin() {
    if (this.debugUrlStart) {
      const debugUrl = this.debugUrlStart + '/' + this.vienti.av
      window.open(debugUrl, '_blank')
    }
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  get viewType(): ViewType {
    const onkoSahkoisetLaskutMaksutavassa = this.maksutapa?.tunniste === SAHKOISET_LASKUT_MAKSUTAPA_ID
    // Tutkitaan ensin tositteen tyyppiä
    if (onkoSahkoisetLaskutMaksutavassa && this.vienti.tt === KirjauksenTositteenTyyppi.SAHKOINEN_OSTOLASKU) {
      return ViewType.SAHKOINEN_OSTOLASKU
    }
    if (onkoSahkoisetLaskutMaksutavassa && this.vienti.tt === KirjauksenTositteenTyyppi.SAHKOINEN_OSTOLASKU_ITSE_LISATTY) {
      return ViewType.SAHKOINEN_OSTOLASKU_ITSE_LISATTY
    }

    // Tositteen tyyppi ei välttämättä määritetty, mutta maksutapa on sähköinen lasku
    if (onkoSahkoisetLaskutMaksutavassa) {
      return ViewType.SAHKOINEN_OSTOLASKU
    }
    return ViewType.NORMAALI
  }
}
